import "./Modals.scss";
import { ModalFullWindow, Typography } from "@bracket/ui";
import { Button } from "@bracket/ui";
import Confetti from "react-confetti";

import WonGif from "./assets/win.gif";
import ConfettiImg from "./assets/confetti.png";
import { useWindowSize } from "usehooks-ts";
import styled from "styled-components";

type WonModalProps = {
  closeModal: () => void;
};

const ConfettiContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -2rem;
  left: -2rem;
`;

export const WonModal = ({ closeModal }: WonModalProps) => {
  const { width = 0, height = 0 } = useWindowSize();

  // Share on X (formerly Twitter) functionality
  const shareOnX = (e) => {
    e.stopPropagation();
    const tweetText = encodeURIComponent(
      "I just stacked free [BARS] playing @bracket_fi's game '[In] Or Out' 💥\n\nYou gotta stake to play! [LFG] fam👇"
    );
    const tweetUrl = encodeURIComponent("https://stake.bracket.fi/");
    const xIntentUrl = `https://twitter.com/intent/tweet?text=${tweetText}&url=${tweetUrl}`;

    window.open(xIntentUrl, "_blank");
    closeModal();
  };

  return (
    <ModalFullWindow>
      <ConfettiContainer>
        <Confetti
          width={width}
          height={height}
          numberOfPieces={200}
          colors={["#03FF8F", "#0fa260", "#127649"]}
          gravity={0.1}
        />
      </ConfettiContainer>
      <img src={WonGif} width={"600px"} />
      <Typography variant="h2">You won!</Typography>
      <Typography variant="textXXL" as="p" color="#F6DD7E">
        + 100 [BARS]
      </Typography>
      <Button
        onClick={shareOnX} // Use the shareOnX function
        label="Share on X to claim!"
        width="300px"
        ml="auto"
        mr="auto"
        mt="auto"
      />
    </ModalFullWindow>
  );
};
